// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ProviderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ERR_ARC_PROVIDER_CONF, SUC_ARC_PROVIDER_CONF } from '../../../../utils/strings';

const useArchiveProviderConfiguration = () => {
  const { submit } = useExerciseSubmission(
    ProviderService.ProviderService_ArchiveProviderConfiguration,
    SUC_ARC_PROVIDER_CONF,
    ERR_ARC_PROVIDER_CONF,
  );

  return submit;
};

export default useArchiveProviderConfiguration;
